// extracted by mini-css-extract-plugin
export default {"main":"Home_main__xjlU2","hello":"Home_hello__DJn+h"};